import { t } from 'ttag'

const primaryTypes = {
  student: { id: 'student', name: t`Student` },
  educator: { id: 'educator', name: t`Educator` },
  counselor: { id: 'counselor', name: t`Career Counselor` },
  family: { id: 'family', name: t`Family Member` },
  workforce: { id: 'workforce', name: t`Employee / Job Seeker` }
}
const studentTypes = {
  k12: { id: 'k12', name: t`K12` },
  higherEd: { id: 'higher_ed', name: t`College / Higher Education` },
  adult: { id: 'adult', name: t`Adult Education Program` }
}
const counselorTypes = {
  librarian: { id: 'librarian', name: t`Librarian` },
  workforce: { id: 'workforce', name: t`Career Counselor` }
}
const educatorTypes = {
  k12: { id: 'k12', name: t`K12` },
  higherEd: { id: 'higher_ed', name: t`College / Higher Education` },
  adult: { id: 'adult', name: t`Adult Education Program` }
}
const k12EducatorTypes = {
  teacher: { id: 'teacher', name: t`Teacher` },
  counselor: { id: 'counselor', name: t`Counselor` },
  administrator: { id: 'administrator', name: t`Administrator` },
  librarian: { id: 'librarian', name: t`Librarian` }
}
const k12Programs = {
  specialEd: { id: 'special_ed', name: t`Special Education` },
  cte: { id: 'cte', name: t`Career & Technical Education` },
  none: { id: 'none', name: t`None` }
}
const k12Populations = {
  elementary: { id: 'elementary', name: t`Elementary School` },
  middle: { id: 'middle', name: t`Middle School` },
  high: { id: 'high', name: t`High School` },
  multiple: { id: 'multiple', name: t`More than one` }
}
const permissions = {
  administrator: 1,
  schoolAdministrator: 2,
  manager: 3,
  user: 4
}
const isNavigator = primaryType => {
  const { educator, counselor, family } = primaryTypes

  return Boolean([educator, counselor, family].find(type => type.id === primaryType))
}
const isExplorer = primaryType => !isNavigator(primaryType)
const hasSchool = user => {
  const { educator, student } = primaryTypes

  return Boolean([educator, student].find(type => type.id === user.primaryType))
}
const getItems = type =>
  Object.entries(type).map(([, { id, name }]) => ({
    value: id,
    label: name
  }))
const initItem = (value, items, defaultTo) =>
  items.find(item => item.value === value) ?? defaultTo

export {
  primaryTypes,
  studentTypes,
  counselorTypes,
  educatorTypes,
  k12EducatorTypes,
  k12Programs,
  k12Populations,
  isNavigator,
  isExplorer,
  hasSchool,
  permissions,
  getItems,
  initItem
}
